import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';


function SettingsList({ title, items, placeholder, onAdd, onDelete }) {
  const [newName, setNewName] = useState('');

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    await onAdd(newName.trim());
    setNewName('');
  };

  return (
    <div className="mb-8 last:mb-0">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">{title}</h2>
      <form onSubmit={handleAdd} className="flex gap-3 mb-6">
        <input type="text" placeholder={placeholder} value={newName} onChange={(e) => setNewName(e.target.value)}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Add</button>
      </form>
      <ul className="divide-y divide-gray-200">
        {items.map((item) => (
          <li key={item.id} className="flex items-center justify-between py-3">
            <span className="text-gray-900">{item.name}</span>
            <button onClick={() => onDelete(item.id)} className="text-blue-600 hover:text-blue-800 text-sm font-medium">Remove</button>
          </li>
        ))}
      </ul>
      {items.length === 0 && <p className="text-gray-500 text-center py-4">None defined yet.</p>}
    </div>
  );
}

export default function CrmSettings() {
  const [tags, setTags] = useState([]);
  const [sources, setSources] = useState([]);

  const loadTags = () => api(`/crm-tags`).then(r => r.json()).then(setTags).catch(() => {});
  const loadSources = () => api(`/contact-sources`).then(r => r.json()).then(setSources).catch(() => {});

  useEffect(() => { loadTags(); loadSources(); }, []);

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow max-w-2xl">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">CRM Settings</h1>
        </div>
        <div className="p-4 md:p-6">
          <SettingsList
            title="Tags"
            items={tags}
            placeholder="New tag..."
            onAdd={async (name) => { await api(`/crm-tags`, { method: 'POST', body: JSON.stringify({ name }) }); loadTags(); }}
            onDelete={async (id) => { await api(`/crm-tags/${id}`, { method: 'DELETE' }); loadTags(); }}
          />
          <SettingsList
            title="Contact Sources"
            items={sources}
            placeholder="New source..."
            onAdd={async (name) => { await api(`/contact-sources`, { method: 'POST', body: JSON.stringify({ name }) }); loadSources(); }}
            onDelete={async (id) => { await api(`/contact-sources/${id}`, { method: 'DELETE' }); loadSources(); }}
          />
        </div>
      </div>
    </Layout>
  );
}
